import { $, $$ } from "@utils/select";
import Flickity from "flickity";
import { isMobile } from "@utils/is-mobile";

const FIX = "flickity-flex";

export default (sliderOptions = {}) => {
  let slider = null;

  const options = {
    prevNextButtons: false,
    pageDots: true,
    cellAlign: "left",
    setGallerySize: false,
    wrapAround: true,
    ...sliderOptions,
  };

  return {
    height: "100vh",
    bar: null,
    $$slides: null,

    init() {
      this.bar = $("#shopify-section-announcement-bar");
      this.$$slides = $$('[x-ref="slide"]', this.$el);

      if (this.bar) {
        this.setHeight();
        window.addEventListener(
          isMobile ? "orientationchange" : "resize",
          this.setHeight.bind(this)
        );
      }

      if (this.$$slides.length > 1) {
        this.$refs.slider.classList.add(FIX);
        slider = new Flickity(this.$refs.slider, options);

        if (!options.desigMode) return;
        document.addEventListener("shopify:block:select", (event) => {
          if (!event.target.classList.contains("js-slider-slide")) return;
          this.selectCell(parseInt(event.target.dataset.idx));
        });

        document.addEventListener("shopify:block:deselect", (event) => {
          if (!event.target.classList.contains("js-slider-slide")) return;
          this.deselectCell();
        });
      }
    },

    setHeight() {
      this.height = window.innerHeight - this.bar.offsetHeight;
    },

    next() {
      slider.next();
    },

    prev() {
      slider.previous();
    },

    selectCell(idx) {
      slider.selectCell(idx);
      slider.pausePlayer();
    },

    deselectCell() {
      slider.selectCell(0);
      slider.unpausePlayer();
    },
  };
};
